module.exports = 10;



// WEBPACK FOOTER //
// ./src/components/limit.js